<template>
  <div>
    <el-image :style="{ width: width, height: height }" :src="getImage(type)" fit="fit"> </el-image>
  </div>
</template>

<script>
import ppt from '@/assets/files/ppt.png';
import pdf from '@/assets/files/pdf.png';
import word from '@/assets/files/word.png';
import xlsx from '@/assets/files/xlsx.png';
import zip from '@/assets/files/zip.png';
import rar from '@/assets/files/rar.png';
import gc from '@/assets/files/gc.png';
import block from '@/assets/files/block.png';
import bot from '@/assets/files/bot.png';
import studio from '@/assets/files/studio.png';
import sf from '@/assets/files/sf.png';
import sjj from '@/assets/files/sjj.png';
export default {
  props: {
    width: {
      type: String,
      default: '40px',
    },
    height: {
      type: String,
      default: '44px',
    },
    type: {
      type: String,
    },
  },
  methods: {
    getImage(type) {
      if (type === 'ppt' || type === 'pptx') {
        return ppt;
      } else if (type === 'pdf') {
        return pdf;
      } else if (type === 'doc' || type === 'docx') {
        return word;
      } else if (type == 'xlsx') {
        return xlsx;
      } else if (type == 'zip') {
        return zip;
      } else if (type == 'rar') {
        return rar;
      } else if (type == 'sk') {
        return block;
      } else if (type == 'py' || type == 'xml') {
        return bot;
      } else if (type == 'Block') {
        return block;
      } else if (type == 'Bot') {
        return bot;
      } else if (type == 'Studio') {
        return studio;
      } else if (type == 'Algorithm') {
        return sf;
      } else if (type == 'Dataset') {
        return sjj;
      } else {
        return '';
      }
    },
  },
};
</script>
